"use strict"

// Form
import { FieldButton } from '@/lib/core/components/data/form/FieldButton'
// Lib
import * as jsf from '@/lib/js_functions'
import * as get_info from '@/lib/get_info'

export class irParaTerrenoButton extends FieldButton {
  #form
  constructor({ form, register, fields, name = 'irParaTerreno', Logic }) {
    super({ form, register, fields, name, Logic, originClass: irParaTerrenoButton })
    this.#form = form
  }
  async clickIrParaTerreno() {
    window.showOverlay()
    const menu = await get_info.getMenuObject({ hmenu: 'data', dataId: 'terrenos' })
    const query = { hmenuOpened: 'Dados', menuId: menu.dataId, folder: menu.folder, menuOpened: menu.title, tabNumber: 2, id: this.#form.register.terreno }
    jsf.openInNewWindow({ name: 'data', query })
    window.hideOverlay()
  }
  async clickVoltarParaTerreno() {
    window.showOverlay()
    const menu = await get_info.getMenuObject({ hmenu: 'data', dataId: 'terrenos' })
    window.routerPush({ name: 'data', query: { hmenuOpened: 'Dados', menuId: menu.dataId, folder: menu.folder, menuOpened: menu.title, tabNumber: 2, id: this.#form.register.terreno } })
      .then(()=>{ window.hideOverlay() })
      .catch((error)=>{ console.log(error); window.hideOverlay() })
  }
}